module.exports = __webpack_public_path__ + "static/media/15UN-Habitat7.c58d43a3.jpg";